import olStyle from "ol/style/Style";
import { StyleFunction as olStyleFunction } from "ol/style/Style";
import olFill from "ol/style/Fill";
import olStroke from "ol/style/Stroke";
import olCircle from "ol/style/Circle";
import olText from "ol/style/Text";
import olIcon from "ol/style/Icon";
import { FeatureLike as olFeatureLike } from "ol/Feature";

const styleCache: { [count: number]: olStyle } = {};

const MaskFill = new olFill({
  color: [0, 0, 0, 0.5],
});

const BoundaryStyle = new olStyle({
  stroke: new olStroke({
    color: "#f78f1e",
    width: 5,
  }),
});

const StationStyle = new olStyle({
  image: new olIcon({
      src: '/rail.svg',
      scale: 0.3
    }),
})

const ClusterStyle: olStyleFunction = (feature: olFeatureLike) => {
  const count = feature.get("features").length;
  let style = styleCache[count];
  if (!style) {
    style = new olStyle({
      image: new olCircle({
        radius: count > 1 ? 10 : 5,
        stroke: new olStroke({
          color: "#fff",
        }),
        fill: new olFill({
          color: "#39c",
        }),
      }),
      text:
        count > 1
          ? new olText({
              text: count.toString(),
              fill: new olFill({
                color: "#fff",
              }),
            })
          : undefined,
    });

    styleCache[count] = style;
  }

  return style;
};

export { MaskFill, StationStyle, BoundaryStyle, ClusterStyle };
